export const SEARCH_HISTORY_BY_MODULE = 'searchHistoryByModule';
export const ACTIVE_FAVORITES_BY_MODULE = 'activeFavoritesByModule';
